// The reference catalog: it defines every key; other catalogs translate it.
// {name} is a named value; a plural text is an object of Intl.PluralRules categories (`other` is required).
const en = {
  'language.name': 'English', // its own name, in its own script; the language menu shows it as it is
  'language.dir': 'ltr',
  'language.label': 'Language',
  'language.current': 'Language: {name}',
  'app.title': 'The Game',
  'wordmark.lead': 'The ',
  'wordmark.accent': 'Game',
  'home.code': 'Game code',
  'home.name': 'Who am I',
  'home.join': 'Join game',
  'home.host': 'Host game',
  'error.gameNotFound': 'Game not found',
  'error.nameTaken': 'Name taken',
  'error.blocked': 'Too many wrong codes. Awkward.',
  'error.general': 'Something went wrong. Try again.',
  'error.duplicateCard': 'That card already exists.',

  'common.yes': 'Yes',
  'common.no': 'No',
  'common.done': 'Done',
  'common.back': 'Back',
  'common.save': 'Save',
  'common.username': 'Username',
  'common.counter': '{n}/{max}',

  'signIn.lead': 'Sign in to host a game\nand build decks of your own',
  'signIn.notInvited': 'This email isn’t on the host list. Yet.',
  'signIn.google': 'Sign in with Google',
  'signIn.joinWithCode': 'Join a game with a code',

  'home.nameHint': 'This name shows in this game only.',
  'home.codePlaceholder': 'XXXX',
  'home.myDecks': 'My decks',
  'home.accountMenu': 'Account menu',
  'home.whatNow': 'What’s the plan',
  'home.joinWithCode': 'Join with a code',
  'home.decksForGame': 'Decks for the game',
  'home.questionCards': 'Question cards',
  'home.answerCards': 'Answer cards',
  'home.noDeck': 'No deck picked',
  'home.pick': 'Pick',
  'home.change': 'Change',
  'home.tileSeparator': ', ',
  'home.tileMore': ' and {count} more',
  'home.tileCount': { one: '1 deck', other: '{count} decks' },
  'home.goneBoth': 'The decks from your last game are gone. Pick at least one question deck and one answer deck.',
  'home.goneQuestion': 'The decks from your last game are gone. Pick at least one question deck.',
  'home.goneAnswer': 'The decks from your last game are gone. Pick at least one answer deck.',
  'home.tooFew': 'Not enough answer cards: you’ve got {count}, you need {min}. Throw in more decks.',
  'home.create': 'Create game',
  'home.creating': 'Create game — loading',
  'home.signedInAs': 'Signed in as',
  'home.myAccount': 'My account',
  'home.signOut': 'Sign out',

  'picker.questionTab': 'Question cards · {count}',
  'picker.answerTab': 'Answer cards · {count}',
  'picker.cardType': 'Card type',
  'picker.createDeck': 'Make a deck',

  'decks.starter': 'Basic',
  'decks.mine': 'Mine',
  'decks.sharedWithMe': 'Shared with me',
  'decks.noneYet': 'No decks of your own yet.',
  'decks.sharedEmpty': 'When someone shares a deck with you, it lands here.',
  'decks.deckType': 'Deck type',
  'decks.newQuestion': 'New question deck',
  'decks.newAnswer': 'New answer deck',
  'decks.ownShared': '{cards} · shared with {count}',
  'decks.sharedRow': '{owner}’s · {cards}',
  'decks.locked': 'Locked',

  'deck.cards': { one: '1 card', other: '{count} cards' },
  'deck.defaultName': 'New deck',
  'deck.answers': { one: '1 answer', other: '{count} answers' },
  'deck.answersThree': '3 answers · everyone draws 2 extra cards',
  'deck.viewHint': 'You can play with this deck. Only the owner gets to change it.',
  'deck.editHint': 'You can add, change and delete cards. Only the owner can delete the deck or share it.',
  'deck.full': {
    one: 'Deck’s full: {count} card. To add a card, delete one.',
    other: 'Deck’s full: {count} cards. To add a card, delete one.',
  },
  'deck.add': 'Add',
  'deck.editCard': 'Edit card',
  'deck.newQuestionCard': 'New question card',
  'deck.newAnswerCard': 'New answer card',
  'deck.cardPlaceholder': 'What’s on the card?',
  'deck.blank': 'Blank',
  'deck.maxBlanks': 'This card already has 2 blanks, that’s the max. It needs 2 answers.',
  'deck.howManyAnswers': 'How many answers',
  'deck.answersHint': 'Only for a card with no blanks. A card with blanks takes one answer per blank, so this choice hides. With 3 answers, everyone draws 2 extra cards from the deck.',
  'deck.share': 'Share',
  'deck.name': 'Deck name',
  'deck.ownedBy': 'By',
  'deck.empty': 'No cards here yet. Write one above and hit “Add”.',
  'deck.editThisCard': 'Edit this card',
  'deck.deleteCard': 'Delete this card',
  'deck.cancelEdit': 'Cancel edit',
  'deck.delete': 'Delete deck',
  'deck.deleteConfirm': 'Delete the deck?',

  'account.hint': 'Friends share decks with you by this name. Anyone you share a deck with sees it.',
  'account.taken': 'That name’s taken. Try another one.',
  'account.delete': 'Delete account',
  'account.deleteConfirm': 'Delete your account?',
  'account.deleteText': 'Your decks get deleted. A deck you shared with edit rights goes to the first person you gave edit rights. No take-backs.',
  'account.passesTo': 'Goes to {name}',
  'account.deleted': 'Gets deleted',
  'account.deleteYes': 'Delete',
  'account.deleteNo': 'Cancel',

  'share.title': 'Share “{name}”',
  'share.level': 'Access',
  'share.view': 'View',
  'share.edit': 'Edit',
  'share.levelsHint': 'View: they can play with the deck. Edit: they can also add, change and delete cards.',
  'share.sharedWith': 'Shared with',
  'share.remove': 'Stop sharing with {name}',
  'share.userNotFound': 'No user by that name',
  'share.ownDeck': 'That’s your own username',

  'game.codeLabel': 'Game code {code}',
  'game.connected': 'Connected',
  'game.connecting': 'Connecting',
  'game.offline': 'Offline',
  'game.leave': 'Leave game',
  'game.leaveConfirm': 'Leave the game?',
  'game.questionCard': 'Black card',
  'game.whoAnswered': 'Who answered',
  'game.answers': 'Answers',
  'game.winner': 'Winner',
  'game.nextPlayer': 'Next player',
  'game.confirmPick': 'For sure?',
  'game.handWritten': 'Handwritten',
  'game.blank': 'Blank',
  'game.answersNeeded': { one: '{count} answer', other: '{count} answers' },
  'game.points': 'Points:',
  'game.inHand': 'In hand:',
  'game.picked': 'Picked:',
  'game.youWon': 'You won!',
  'game.roundWinner': 'Round winner:',
  'game.questionComing': 'Black card on its way',
  'game.send': 'Send answer',
  'game.sentCard': 'Black card — your answer is in',
  'game.blankUsed': 'Blank card used — back next round',
  'game.writeYourOwn': 'Write your own',
  'game.blankCard': 'Blank card — write your own',
  'game.yourCard': 'Your card',
  'game.yourCardText': 'Your card: {text}',
  'game.yourCardInBlank': 'Your card: {text} — {blank}',
  'game.cardInBlank': '{text} — {blank}',
  'game.blank1': 'First blank',
  'game.blank2': 'Second blank',
  'game.blank3': 'Third blank',
  'game.saveWritten': 'Save',

  'end.randomWon': 'Rando won',
  'end.fatality': 'Fatality.',
  'end.home': 'Back to home',
  'end.over': 'Game over',
  'end.hostGone': 'The host left and didn’t come back in time, so we shut the game down.',

  'intro.welcome': 'Welcome',
  'intro.howTo': 'Here’s how to play, in half a minute',
  'intro.judgeTitle': 'Every round has a judge',
  'intro.judgeText': 'The judge draws a question card with a blank.',
  'intro.question': 'My secret to success in life:',
  'intro.chooseTitle': 'Everyone picks an answer',
  'intro.chooseText': 'All the other players pick the funniest card in their hand.',
  'intro.pickTitle': 'The judge picks a winner',
  'intro.pickText': 'The judge reads every answer. The best one scores a point.',
  'intro.point': 'A point for {name}',
  'intro.nextTitle': 'The turn moves on',
  'intro.nextText': 'Next round, the next player is the judge.',
  'intro.judge': 'Judge',
  'intro.randoTitle': 'Meet Rando',
  'intro.randoText': 'Every round, Rando throws in a random answer. If the judge picks it 3 times, the game is over.',
  'intro.randoTally': 'Rando won 3 times',
  'intro.randoWon': 'Rando wins',
  'intro.ready': 'Let’s go!',
  'intro.readyText': 'Now you know it all.',
  'intro.play': 'Let’s play',
  'intro.skip': 'Skip',
  'intro.hand1': 'Ranch on everything',
  'intro.hand2': 'A fight over the thermostat',
  'intro.hand3': 'Tacos at 3am',
  'intro.hand4': 'Parking in Manhattan',
  'intro.player1': 'Emma',
  'intro.player2': 'Jake',
  'intro.player3': 'Mia',
  'intro.player4': 'Tom',
};

export default en;
